import { render } from "./VetConsultPay.vue?vue&type=template&id=f167247a&scoped=true"
import script from "./VetConsultPay.vue?vue&type=script&lang=js"
export * from "./VetConsultPay.vue?vue&type=script&lang=js"

import "./VetConsultPay.vue?vue&type=style&index=0&id=f167247a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f167247a"]])

export default __exports__